import { Tooltip } from '@shopify/polaris';
import RegularText from '../RegularText';
import {
  COUNTRY,
  END_DATE_MARKER,
  FLAG,
  PREP_END_DATE_MARKER,
  PREP_START_DATE_MARKER,
  START_DATE_MARKER,
  TIME_COUNTDOWN_MARKER,
  ZIPCODE,
} from '@/constants/string';
import { InfoIcon } from '../Icons';

interface IProps {
  hideCountDown?: boolean;
  isInCountryPage?: boolean;
  hideGeography?: boolean;
}

const VariableTooltips = (props: IProps) => {
  return (
    <RegularText>
      {'You can include these variables:'}
      {!props.hideCountDown ? (
        <>
          {` ${TIME_COUNTDOWN_MARKER}`}
          <Tooltip content={'Countdown timer'}>
            <span className="ml-4">
              <InfoIcon />
            </span>
          </Tooltip>
        </>
      ) : null}
      {` ${START_DATE_MARKER}`}
      <Tooltip content={'Minimum date of delivery'}>
        <span className="ml-4">
          <InfoIcon />
        </span>
      </Tooltip>
      {` ${END_DATE_MARKER}`}
      <Tooltip content={'Maximum date of delivery'}>
        <span className="ml-4">
          <InfoIcon />
        </span>
      </Tooltip>
      {` ${PREP_START_DATE_MARKER}`}
      <Tooltip content={'Minimum date of preparation'}>
        <span className="ml-4">
          <InfoIcon />
        </span>
      </Tooltip>{' '}
      {` ${PREP_END_DATE_MARKER}`}
      <Tooltip content={'Maximum date of preparation'}>
        <span className="ml-4">
          <InfoIcon />
        </span>
      </Tooltip>
      {!props.hideGeography ? (
        <>
          {` ${COUNTRY}`}
          <Tooltip content={'Name of country and region'}>
            <span className="ml-4">
              <InfoIcon />
            </span>
          </Tooltip>
          {` ${FLAG}`}
          <Tooltip content={'Flag of country'}>
            <span className="ml-4">
              <InfoIcon />
            </span>
          </Tooltip>
          {` ${ZIPCODE}`}
          <Tooltip content={'Selected zipcode'}>
            <span className="ml-4">
              <InfoIcon />
            </span>
          </Tooltip>
        </>
      ) : null}
    </RegularText>
  );
};

export default VariableTooltips;
